import { gql } from '@apollo/client'

export type GetGnowbeAiLimitPerOrganizationRes = {
  res: {
    addon: string;
    title: string;
    description: string;
    price: number;
    freeCredits: number;
    status: 'active' | 'inactive';
    count: number;
    limit: number;
    feature: 'ai' | 'translation',
    freeCreditsLeft: number,
    addonBonusCredits: number,
    freeCreditsForCurrentPeriod: number,
    remainingCredits: number,
    step: number,
    stepMin: number,
    stepMax: number,
    countUnit: 'words' | 'credits',
    billingCycle: 'year' | 'month' | 'quarter' | 'null',
    /**
     * Whether this workspace meters AI Tasks per creator.
     *
     * When true, `remainingCredits` above is still the *workspace pool* — not what
     * the caller may spend. Use `creator.availableCredits` for that, or the
     * translator will offer a figure the server will refuse.
     */
    creatorCreditsEnforced?: boolean,
    /**
     * The caller's own allocation in this workspace. Null when not metered per creator.
     *
     * Shaped to match `AiCreatorCredits` in components/gnowbeAi/types so the value
     * can be handed straight to `getAiCreditsState` and `AiCreditsNotice` — `status`
     * is optional there, and GraphQL sends null rather than omitting it.
     */
    creator?: {
      isAssigned: boolean,
      status?: string,
      assignedCredits: number,
      spentCredits: number,
      availableCredits: number,
    } | null,
  }
}

export type GetGnowbeAiLimitPerOrganizationVars = {
  organizationId: string;
}

export const GetGnowbeAiLimitPerOrganizationQuery = gql`
  query GetGnowbeAiLimitPerOrganization ($organizationId: String!) {
    res: getGnowbeAiLimitPerOrganization (organizationId: $organizationId){
      addon
      title
      description
      price
      count
      limit
      freeCredits
      status
      feature
      freeCreditsLeft
      addonBonusCredits
      freeCreditsForCurrentPeriod
      remainingCredits
      step
      stepMin
      stepMax
      countUnit
      billingCycle
      creatorCreditsEnforced
      creator {
        isAssigned
        status
        assignedCredits
        spentCredits
        availableCredits
      }
    }
  }
`

